// src/components/assets/AssetFilters.jsx
import React from 'react';

const AssetFilters = ({ filters, onChange }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange({ ...filters, [name]: value });
  };

  const handleClear = () => {
    onChange({});
  };

  return (
    <div className="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6 mb-6">
      <div className="md:grid md:grid-cols-4 md:gap-6">
        <div className="md:col-span-1">
          <h3 className="text-lg font-medium leading-6 text-gray-900">Filter Assets</h3>
          <p className="mt-1 text-sm text-gray-500">
            Use these filters to narrow down the list of assets.
          </p>
        </div>
        <div className="mt-5 md:mt-0 md:col-span-3">
          <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div className="sm:col-span-2">
              <label htmlFor="asset_type" className="block text-sm font-medium text-gray-700">
                Asset Type
              </label>
              <div className="mt-1">
                <select
                  id="asset_type"
                  name="asset_type"
                  value={filters.asset_type || ''}
                  onChange={handleChange}
                  className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                >
                  <option value="">All Types</option>
                  <option value="PLC">PLC</option>
                  <option value="RTU">RTU</option>
                  <option value="HMI">HMI</option>
                  <option value="Sensor">Sensor</option>
                  <option value="Controller">Controller</option>
                  <option value="Gateway">Gateway</option>
                  <option value="SCADA">SCADA System</option>
                  <option value="Other">Other</option>
                </select>
              </div>
            </div>

            <div className="sm:col-span-2">
              <label htmlFor="location" className="block text-sm font-medium text-gray-700">
                Location
              </label>
              <div className="mt-1">
                <input
                  type="text"
                  name="location"
                  id="location"
                  value={filters.location || ''}
                  onChange={handleChange}
                  placeholder="Location"
                  className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                />
              </div>
            </div>

            <div className="sm:col-span-2">
              <label htmlFor="vendor" className="block text-sm font-medium text-gray-700">
                Vendor
              </label>
              <div className="mt-1">
                <input
                  type="text"
                  name="vendor"
                  id="vendor"
                  value={filters.vendor || ''}
                  onChange={handleChange}
                  placeholder="Vendor name"
                  className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                />
              </div>
            </div>
          </div>

          <div className="flex justify-end mt-6 space-x-3">
            <button
              type="button"
              onClick={handleClear}
              className="py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Clear Filters
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssetFilters;
